import React, { createContext, useState, useContext } from "react";
import {converterParaNumero} from '../function/funcionalidades'

const DataContext = createContext();

export const Methods = ({ children }) => {
  const [listaGastos,setListaGastos] = useState([]);
  const [listaReceitas, setListaReceitas] = useState([]);

  const addGasto = (novaDespesa) => {
  setListaGastos((despesaAnterior) => [...despesaAnterior, novaDespesa]);
  };

  const addReceita = (novaReceita) => {
    setListaReceitas((receitaAnterior) => [...receitaAnterior, novaReceita]);
  };

  const somar = (lista) => {
    let tot = 0;
    for (let i = 0; i < lista.length; i++) {
      tot += Number(lista[i].valor);
    }
    return tot;
  };

  const deletarGasto = (id) => {
  setListaGastos((prev) => prev.filter((item) => item.id !== id));
  };

  const alterarGasto = (id, nome, valor, mes) => {
  setListaGastos((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, nome, valor: Number(valor), mes }
          : item
      )
    );
  };
  
  const deletarReceita = (id) => {
    setListaReceitas((prev) => prev.filter((item) => item.id !== id));
  };

  const alterarReceita = (id, nome, valor) => {
    setListaReceitas((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, nome, valor: Number(valor) }
          : item
      )
    );
  };

  const divdir = (valor) =>{
    const valorCada = converterParaNumero(valor) / 12
    return valorCada
  }

  return (
    <DataContext.Provider
      value={{
        listaGastos,
        listaReceitas,
        addGasto,
        addReceita,
        somar,
        deletarGasto,
        deletarReceita,
        alterarGasto,
        alterarReceita,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);